import React from 'react'
import '../css/nav.css'
import { Link } from 'react-router-dom';
import Loanbtn from './Loanbtn'
import { useSelector } from 'react-redux';

// const closeNavbar = () => {
//     const navbar = document.querySelector(".offcanvas.offcanvas-end.show");
//     const body = document.querySelector(".offcanvas-backdrop.fade.show");
//     if (navbar) {
//         navbar.classList.remove("show");
//     }
//     if (body) {
//         body.classList.remove("show");
//     }
// };


export default function Header() {
    const brandName = process.env.REACT_APP_COMPANY_N
    const brandLogo = process.env.REACT_APP_LOGO
    const customerDetails = useSelector((state) => state?.customerJourneyDetails?.customerDetails);
    const checklogin = customerDetails?.token;
    return (
        <>

            {/* <Link className="navbar-brand" to="/" style={{ margin: '0 auto' }}>
                    <img src={`/${brandLogo}`} alt={brandName} />
                  </Link> */}

            {/* <img src={/${brandLogo}} alt={brandName} /> */}
            <nav className="navbar navbar-expand-lg fixed-top bg-white" style={{padding:'0'}}>
                <div className="container">
                    <Link className="navbar-brand" to="/">
                        <img src={`/${brandLogo}`} alt={brandName}  width={'50px'}/>
                            <span className='text-lg sm:text-2xl font-bold bg-gradient-to-r from-purple-600 to-orange-500 bg-clip-text text-transparent'>SnapRupee </span>


                    </Link>
                    <div className='mobile-menu attr-nav flex'>
                        <div data-bs-toggle="offcanvas" data-bs-target="#offcanvasRight" aria-controls="offcanvasRight">
                            <li className='side-menu' style={{ position: 'relative' }}>
                                <Link>
                                    <span className='bar-1'></span>
                                    <span className='bar-2'></span>
                                    <span className='bar-3'></span>
                                </Link>
                            </li>
                        </div>
                    </div>

                    <div className="collapse navbar-collapse" id="navbarSupportedContent">
                        <div className="navbar-nav me-auto mb-2 mb-lg-0">
                            {/* <h5 style={{ paddingLeft: '40px' }}>
                                <EmailIcon /> info@snaprupee.in  | &nbsp;
                                <CallIcon /> +91: 8586851990
                            </h5> */}
                        </div>
                        <div className="d-flex gap-3 position-relative align-items-center">
                           {checklogin ? (
                            <Link to='/apply-now'><Loanbtn title="Dashboard" /></Link>
                        ) : (
                            <Link to='/apply-now'><Loanbtn title="Apply Now" /></Link>
                        )}

                            <Link to='repay-loan' className='btn-paynow'>Pay Now</Link>
                            {/* <Link to='repay-loan'><Loanbtn title="Pay Now" style={{background:'red'}} /></Link> */}


                            <div className='attr-nav flex' style={{ borderLeft: '1px solid #ddd' }}>
                                <h4>MENU</h4>
                                <div data-bs-toggle="offcanvas" data-bs-target="#offcanvasRight" aria-controls="offcanvasRight">
                                    <li className='side-menu' style={{ position: 'relative' }}>
                                        <Link>
                                            <span className='bar-1'></span>
                                            <span className='bar-2'></span>
                                            <span className='bar-3'></span>
                                        </Link>
                                    </li>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </nav>
            <div className="offcanvas offcanvas-end" tabIndex="-1" id="offcanvasRight" aria-labelledby="offcanvasRightLabel">
                <div className="offcanvas-header">
                    <h5 id="offcanvasRightLabel" className='fw-semibold text-uppercase'> SnapRupee  <span className='ms-takeaways'>Paisa</span></h5>
                    <button type="button" className="btn-close text-reset" data-bs-dismiss="offcanvas" aria-label="Close"></button>
                </div>
                <div className="offcanvas-body ms-side-nav">
                    <ul>
                        <li className="text-reset" data-bs-dismiss="offcanvas"  >
                            <Link to='/' >Home</Link>
                        </li>
                        <li className="text-reset" data-bs-dismiss="offcanvas">
                            <Link to='/about' >About Us</Link>
                        </li>
                        <li className="text-reset" data-bs-dismiss="offcanvas">
                            <Link to='/short-term-loan'>Short Term Loan</Link>
                        </li>
                        <li className="text-reset" data-bs-dismiss="offcanvas">
                            <Link to='/instant-personal-loan' > Instant Personal Loan</Link>
                        </li>
                        <li className="text-reset" data-bs-dismiss="offcanvas">
                            <Link to='/emergency-loan' > SnapRupee  Loan</Link>
                        </li>
                        <li className="text-reset" data-bs-dismiss="offcanvas">
                            <Link to='/contact' > Contact</Link>
                        </li>
                        <li className="text-reset" data-bs-dismiss="offcanvas">
                            {checklogin ? (
                            <Link to='/apply-now'>Dashboard</Link>
                        ) : (
                            <Link to='/apply-now'>Apply Now</Link>
                        )}
                            
                        </li>
                        <li className="text-reset" data-bs-dismiss="offcanvas">
                            <Link to='/repay-loan'> Pay Now</Link>
                        </li>
                    </ul>
                </div>
            </div>
        </>
    )
}